<template>
  <v-dialog
    v-model="dialog"
    width="448"
    open-on-focus
    no-click-animation
    persistent
    content-class="new-file-dialog"
    @click:outside="onClickOutside"
    @keydown="onKeydown"
  >
    <v-card elevation="0">
      <v-form ref="form" class="new-file-form" @submit.prevent="onSubmit">
        <div class="new-file-form-body">
          <v-toolbar
            flat
            height="76"
          >
            <v-toolbar-title class="new-file-toolbar-title">Create content</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn
              color="accent"
              icon
              tile
              @click="closeDialog"
            >
              <v-icon size="24">mdi-close</v-icon>
            </v-btn>
          </v-toolbar>
          <!-- file -->
          <v-container class="new-file-card-container">
            <v-row>
              <v-col sm="12">
                <dialog-input
                  label="Title"
                  name="title"
                  :value="newFileData.title"
                  @input="onInput" />
                </v-col>
            </v-row>
          </v-container>
          <v-container class="new-file-card-container py-0">
            <v-row>
              <v-col sm="12">
                <dialog-input
                  label="Description"
                  name="description"
                  :value="newFileData.description"
                  @input="onInput" />
                </v-col>
            </v-row>
          </v-container>
          <v-container class="new-file-card-container py-0">
            <v-row>
              <v-col sm="12">
                <dialog-file
                  label="Upload file"
                  name="file"
                  :value="newFileData.file"
                  :accept="getMimeTypes([18, 19, 20, 21, 22, 23])"
                  @input="onInput" 
                  @change="onChange" />
                </v-col>
            </v-row>
          </v-container>
          <v-container class="new-file-card-container py-0" v-if="showNotifyCheck">
            <v-row>
              <v-col sm="12">
                <v-switch
                  class="v-input--reverse"
                  color="accent"
                  name="notify"
                  :value="newFileData.notify"
                  @change="onSwitchNotify"
                >
                  <template #label>
                    <v-list-item-subtitle>
                      Notify participant
                    </v-list-item-subtitle>
                  </template>
                </v-switch>
              </v-col>
            </v-row>
          </v-container>
          <v-container class="new-file-card-footer d-flex justify-end">
            <v-btn
              :disabled="!formIsValid"
              rounded
              color="primary"
              type="submit"
              elevation="0"
            >
              Create
            </v-btn>
          </v-container>
        </div>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import DialogInput from '@/components/forms/DialogInput.vue'
import DialogFile from '@/components/forms/DialogFileInput.vue'

const emptyForm = {
  file: null,
}

export default {
  name: 'NewFileDialog',
  components: {
    DialogInput,
    DialogFile
  },
  props: {
    showDialog: {
      type: Boolean,
      default: false
    },
    getMimeTypes: {
      type: Function,
      default: () => null
    },
    showNotifyCheck: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      dialog: false,
      newFileData: { ...emptyForm },
      formIsValid: false
    }
  },
  watch: {
    showDialog: function (val) {
      if (val) {
        this.dialog = true
      }
    }
  },
  computed: {
     
  },
  methods: {
    formValidate() {
      if (this.newFileData.file && this.newFileData.file.type !=='image/webp' && this.newFileData.title && this.newFileData.title.trim() !== '')
        this.formIsValid = true
      else this.formIsValid = false
    },
    closeDialog () {
      this.dialog = false
      this.$emit('close-dialog')
    },
    onClickOutside() {
      this.closeDialog()
    },
    onKeydown(key) {
      if (key.code === "Escape" && key.isTrusted) this.closeDialog()
    },
    onInput ({ name, value }) {
      this.newFileData[name] = value
      this.$emit('on-change', { ...this.newFileData })
      this.formValidate()
    },
    onChange(event) {
      this.newFileData['file'] = event
      this.$emit('on-change', { ...this.newFileData })
      this.formValidate()
    },
    onSwitchNotify(value) {
      this.newFileData['notify'] = value
      this.$emit('on-change', { ...this.newFileData })
      this.formValidate()
    },
    clearForm () {
      this.$refs.form.reset()
      this.newFileData = { ...emptyForm }
      this.formValidate()
    },
    onSubmit () {
      this.$emit('on-submit', { ...this.newFileData })
      this.clearForm()
      this.closeDialog()
    }
  }
}
</script>

<style lang="scss">
@import "@/styles/variables.scss";

.new-file {
  &-dialog {
    margin: $gutter;
    margin-left: auto;
    height: 100%;
    max-height: calc(100% - #{2*$gutter}) !important;
    > .v-card {
      width: 100%;
      height: 100%;
    }
  }
  &-toolbar-title {
    color: $bh-blue;
    font-size: 1.5715rem;
    font-weight: bold;
  }
  &-tabs {
    padding:0 24px;
    background:#ffffff;
    .v-tab {
      color:$bh-blue;
      text-transform: none;
      letter-spacing: 0;
      font-size: 1em;
      &:not(.v-tab--active) {
        color:white;
      }
    }
    .v-tabs-slider {
      background:$bh-blue;
    }
  }
  &-v-tabs-items {
    background:$bh-blue--4 !important;
  }
  &-card {
    &-title {
      font-size: $font-size-root;
      color: $bh-gray--2;
      padding-left: 1.5*$gutter;
      padding-right: 1.5*$gutter;
    }
    &-container {
      padding-left: 1.5*$gutter;
      padding-right: 1.5*$gutter;
      padding-top:10px;
    }
    &-footer {
      padding: 1.5*$gutter;
    }
  }
  &-form {
    background-color: $bh-blue--4;
    height: 100%;
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    overflow: auto;

    &-body {
      ::v-deep .v-toolbar__content {
        padding-left: 1.5*$gutter;
        padding-right: 1.5*$gutter;
      }
    }
    &-col-left {
      padding-top: 0;
      padding-right: 0.25*$gutter;
    }
    &-col-right {
      padding-top: 0;
      padding-left: 0.25*$gutter
    }
  }
}
</style>
